import styled from '@emotion/styled';

export const MainContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  position: relative;
  
  width: 100vw;
  height: calc(100vh - 56px);
  background-color: black;
  
  margin: auto;
  
  top: 0;
  max-width: 700px;
  max-height: -webkit-fill-available;
  z-index: 10;
`;

export const PageTitle = styled.div`
  display: flex;
  align-items: center;
  width: fit-content;
  height: 50px;
  margin: auto;
  
  font-weight: 700;
  font-size: 24px;
  line-height: 28px;
`;

export const PageContent = styled.div`
  padding: 0 15px 50px 15px;
  height: calc(100% - 106px);

  display: flex;
  flex-direction: column;
  justify-content: space-between;
  overflow: scroll;
  
  a {
    color: inherit;
  }
`;

export const BottomShadow = styled.div`
  position: absolute;
  width: 390px;
  height: 76px;
  left: 0;
  bottom: 0;

  background: linear-gradient(180deg, #00000000 1.5%, #000000 85%);

`;
